import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import PostConstruction from "./pages/service-pages/PostConstruction";
import TrainingCertifying from "./pages/service-pages/TrainingCertifying";
import HiringMaids from "./pages/service-pages/HiringMaids";
import Fumigation from "./pages/service-pages/Fumigation";
import RoofTileCleaning from "./pages/service-pages/RoofTileCleaning";
import DeepCleaning from "./pages/service-pages/DeepCleaning";
import LaundryFromHomes from "./pages/service-pages/LaundryFromHomes";
import VacuumCleaning from "./pages/service-pages/VacuumCleaning";
import EventCleaning from "./pages/service-pages/EventCleaning";

import NotFound from "./pages/NotFound";
import PricingPage from "./pages/Pricing";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/services" element={<Services />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route
        path="/services/post-construction"
        element={<PostConstruction />}
      />
      <Route
        path="/services/training-certifying"
        element={<TrainingCertifying />}
      />
      <Route path="/services/hiring-maids" element={<HiringMaids />} />
      <Route path="/services/fumigation" element={<Fumigation />} />
      <Route
        path="/services/roof-tile-cleaning"
        element={<RoofTileCleaning />}
      />
      <Route path="/services/deep-cleaning" element={<DeepCleaning />} />
      <Route
        path="/services/laundry-from-homes"
        element={<LaundryFromHomes />}
      />
      <Route path="/services/vacuum-cleaning" element={<VacuumCleaning />} />
      <Route path="/services/event-cleaning" element={<EventCleaning />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
